import React, { useEffect, useState } from "react";
import pb from "../../../lib/pocketbase";
import { IExpenseListRecord, IExpenseRecord } from "../../../lib/types";
import { Link } from "react-router-dom";
import Button from "../../../components/form/button";
import { formatToEuro } from "../../../lib/utils";
import NewList from "../../../components/studio/expenses/newList";

export interface IExpenseListWithTotalRecord extends IExpenseListRecord {
    total: number;
    expand: {
        "expense(list)": IExpenseRecord[];
    };
}

export default function ExpenseLists() {
    const [lists, setLists] = useState<IExpenseListWithTotalRecord[]>([]);
    const [showArchived, setShowArchived] = useState(false);
    async function loadLists() {
        const l: IExpenseListWithTotalRecord[] = await pb.collection("expenseList").getFullList({
            expand: "expense(list)"
        });
        l.map((list) => {
            list.total = list.expand["expense(list)"]?.reduce((total, expense) => {
                if (expense.income) return total + expense.amount * expense.price;
                else return total - expense.amount * expense.price;
            }, 0);
        });
        setLists(l);
    }
    useEffect(() => {
        loadLists();
    }, []);
    return (
        <div className="mt-4">
            <div className="flex justify-end">
                <NewList>
                    <Button>Add list</Button>
                </NewList>
            </div>
            <div className="mt-4 flex flex-col gap-4">
                {lists
                    .filter((x) => !x.archive)
                    .map((list) => (
                        <Link to={`/studio/expenses/list/${list.id}`}>
                            <Button variant={"ghost"} size={"ghost"} className="flex w-full items-center justify-between rounded-lg border px-6 py-4 active:scale-95">
                                {list.name}
                                <span className="font-bold">{formatToEuro(list.total || 0)}</span>
                            </Button>
                        </Link>
                    ))}

                {showArchived ? (
                    <div className="mt-8">
                        <div className="mb-4 flex items-center justify-between">
                            <h3 className=" text-xl font-medium">Archived lists:</h3>
                            <Button onClick={() => setShowArchived(false)}>Hide</Button>
                        </div>
                        {lists
                            .filter((x) => x.archive)
                            .map((list) => (
                                <Link to={`/studio/expenses/list/${list.id}`}>
                                    <Button variant={"ghost"} size={"ghost"} className="flex w-full items-center justify-between rounded-lg border px-6 py-4 active:scale-95">
                                        {list.name}
                                        <span className="font-bold">{formatToEuro(list.total || 0)}</span>
                                    </Button>
                                </Link>
                            ))}
                    </div>
                ) : (
                    <Button className="w-fit" onClick={() => setShowArchived(true)}>
                        Show archived lists
                    </Button>
                )}
            </div>
        </div>
    );
}
